import { createSlice } from "@reduxjs/toolkit";

const tokenSlice = createSlice({
  name: "tokenSlice",
  initialState: {
    token: "",
  },

  reducers: {
    setActivationToken: (state, action) => {
      state.token = action.payload;
    },
  },
});

export const { setActivationToken } = tokenSlice.actions;

export default tokenSlice.reducer;
